module.exports = __webpack_public_path__ + "assets/1984b6c82a6dee2c5bd43658d34cbd4b.png";